import { useCallback } from 'react';
import moment from 'moment/moment';

import ColorButton from '../../shared/ColorButton';

import { parseNetDate } from '../../../utils/utils';
import { blueBorderColor, greenBorderColor, lightGreenColor, lightGreyColor } from '../../../utils/colors';

import unleashedLogo from '../../../assets/unleashed_logo.png';

const ExportUsageUnleashed = (props) => {
  const { unleashedSalesOrder, onSendUsageToUnleashed, loading, usageIntegrationData, users = [] } = props;

  const getUserName = useCallback((uid) => {
    const user = users.find((u) => u.uid === uid);
    return user ? `${user.firstName} ${user.lastName}` : '';
  }, [users]);


  return (
    <div>
      <div className='secondary'>API Integration</div>
      <div
        className='p-lg m-t-md'
        style={{
          border: `1px solid ${unleashedSalesOrder ? greenBorderColor : blueBorderColor}`,
          borderRadius: '12px',
          background: '#ffffff'
        }}
      >
        <div className='d-flex space-between align-start'>
          <div className='d-flex'>
            <img src={unleashedLogo} alt='unleashed_logo' style={{ width: '24px' }} />
            <div className='m-l-sm font-bold'>Unleashed Software</div>
          </div>
          {unleashedSalesOrder ? (
            <div
              style={{
                padding: '4px 40px',
                borderRadius: '8px',
                background: lightGreenColor,
                height: '40px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Success
            </div>
          ) : (
            <ColorButton
              onClick={onSendUsageToUnleashed}
              color='blue'
              text="Post Usage"
              fontSize={14}
              disabled={loading}
              loading={loading}
            />
          )}
        </div>

        {unleashedSalesOrder ? (
          <div className='m-t-lg'>
            <table className='width-100'>
              <thead>
              <tr>
                <th className='secondary'>Order </th>
                <th className='secondary'>Created on</th>
                <th className='secondary'>Created by</th>
                <th className='secondary'>Status</th>
              </tr>
              </thead>
              <tbody>
              <tr key={unleashedSalesOrder?.Guid}>
                <td className='font-bold'>{unleashedSalesOrder?.OrderNumber}</td>
                <td className='font-bold'>{unleashedSalesOrder?.CreatedOn ? moment(parseNetDate(unleashedSalesOrder?.CreatedOn)).format('DD/MM/YYYY HH:mm') : ''}</td>
                <td className='font-bold'>{getUserName(usageIntegrationData?.createdBy)}</td>
                <td className='font-bold'>{unleashedSalesOrder?.OrderStatus}</td>
              </tr>
              </tbody>
            </table>

            <div className='m-t-lg'>
              <div
                style={{
                  padding: '4px 16px',
                  borderRadius: '8px',
                  background: lightGreyColor,
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '12px'
                }}
              >
                {`${unleashedSalesOrder?.SalesOrderLines?.length || 0} Order Lines successfully created`}
              </div>
            </div>
          </div>
        ) : (
          <div className='d-flex flex-center secondary p-lg font-bold'>
            Post usage to raise sales order
          </div>
        )}
      </div>
    </div>
  )
};

export default ExportUsageUnleashed;
